import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../fields/Checkbox';

import styles from './Checkbox.less';

const noop = () => {};

/**
 * **Access:**
 * ```js
 * import {Columns} from '@iss/client-react-components';
 *
 * <Table columns={[ Columns.Checkbox, ... ]} />
 * ```
 *
 * A Column that provides the multi-selection interface
 *
 * @class CheckboxColumn
 */
export default class CheckboxColumn extends React.PureComponent {
  static propTypes = {
    /**
     *
     *
     * @type {bool}
     */
    selected: PropTypes.bool,
  };

  static cssClassName = styles.cell;

  static HeaderComponent = () => <span />;

  static withSelectAll(onSelectAll, checked) {
    return class extends CheckboxColumn {
      static HeaderComponent = (props) => <Checkbox checked={checked} onChange={noop} onClick={onSelectAll} />;
    };
  }

  render() {
    const {
      props: { selected },
    } = this;

    return <Checkbox checked={selected} onChange={noop} />;
  }
}
